module.exports = __webpack_public_path__ + "img/100_porcento_virtual_icon.2d16ec94.svg";